var map = {
	"./ansar.png": "1912",
	"./ayandeh.png": "a4f0",
	"./central-bank.png": "b7de",
	"./dey.png": "c16e",
	"./eghtesad-novin.png": "afef",
	"./gardeshgari.png": "e9cc",
	"./ghavamin.png": "fb2b",
	"./hekmat-iranian.png": "d77c",
	"./iran-venezuela.png": "494e",
	"./iran-zamin.png": "f5db",
	"./karafarin.png": "c084",
	"./keshavarzi.png": "659a",
	"./markazi.png": "4c5e",
	"./maskan.png": "85fe",
	"./mehr-iran.png": "f53d",
	"./mellat.png": "32af",
	"./melli.png": "78d6",
	"./parsian.png": "7f43",
	"./pasargad.png": "36a0",
	"./post.png": "6c46",
	"./refah.png": "c56d",
	"./resalat.png": "f004",
	"./saderat.png": "2b92",
	"./saman.png": "109e3",
	"./sanat-o-madan.png": "e263",
	"./sarmayeh.png": "f529",
	"./sepah.png": "54ab",
	"./shahr.png": "4dd2",
	"./sina.png": "ac05",
	"./tejarat.png": "64036",
	"./toose-taavon.png": "f675",
	"./tosee-saderat.png": "597a",
	"./tosee.png": "c4ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d106";